module.exports = __webpack_public_path__ + "img/Port affairs handling_wei.7c01f413.png";